(function () {
  'use strict';
  if (window.__emaGlueOfferInstalled) return;
  window.__emaGlueOfferInstalled = true;

  // Read config lazily so the async API fetch in the liquid snippet
  // has time to overwrite window.__emaCartAuto before these values are used.
  function getCfg() { return window.__emaCartAuto || {}; }

  var CORAL_GLUE_VARIANT_ID = (window.__emaCartAuto || {}).glueVariantId;
  if (!CORAL_GLUE_VARIANT_ID) return;

  // ─── Confetti ─────────────────────────────────────────────────────────────

  var COLORS = ['#ff6b6b','#ffd93d','#6bcb77','#4d96ff','#ff922b','#cc5de8','#f06595','#74c0fc'];

  function launchConfetti() {
    var canvas = document.createElement('canvas');
    // Inline styles applied before DOM insertion — prevents any layout shift
    canvas.style.cssText = 'position:fixed;top:0;left:0;width:100vw;height:100vh;pointer-events:none;z-index:9999;display:block;';
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    document.body.appendChild(canvas);

    var ctx = canvas.getContext('2d');
    var cx = canvas.width / 2;
    var cy = canvas.height / 2;
    var pieces = [];
    var count = 160;

    for (var i = 0; i < count; i++) {
      var angle = Math.random() * Math.PI * 2;
      var speed = 6 + Math.random() * 16;
      pieces.push({
        x: cx,
        y: cy,
        w: 7 + Math.random() * 7,
        h: 3 + Math.random() * 5,
        color: COLORS[Math.floor(Math.random() * COLORS.length)],
        rotation: Math.random() * Math.PI * 2,
        spin: (Math.random() - 0.5) * 0.3,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed,
        opacity: 1,
        shape: Math.random() > 0.5 ? 'rect' : 'circle'
      });
    }

    var frame;
    var start = null;
    var duration = 3200;

    function draw(ts) {
      if (!start) start = ts;
      var elapsed = ts - start;
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      pieces.forEach(function (p) {
        p.x += p.vx;
        p.y += p.vy;
        p.vx *= 0.97;
        p.vy *= 0.97;
        p.vy += 0.25;
        p.rotation += p.spin;
        if (elapsed > duration * 0.5) p.opacity = Math.max(0, p.opacity - 0.022);

        ctx.save();
        ctx.globalAlpha = p.opacity;
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rotation);
        ctx.fillStyle = p.color;
        if (p.shape === 'circle') {
          ctx.beginPath();
          ctx.arc(0, 0, p.w / 2, 0, Math.PI * 2);
          ctx.fill();
        } else {
          ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
        }
        ctx.restore();
      });

      if (elapsed < duration) {
        frame = requestAnimationFrame(draw);
      } else {
        canvas.remove();
      }
    }

    frame = requestAnimationFrame(draw);
    return function () { cancelAnimationFrame(frame); canvas.remove(); };
  }

  // ─── Modal ────────────────────────────────────────────────────────────────
  // z-index layers:
  //   9998 — dark backdrop
  //   9999 — confetti canvas  (behind modal card, in front of backdrop)
  //  10000 — modal centering wrapper + card

  // ─── Analytics tracking ───────────────────────────────────────────────────

  // EMA 2026-10-31: the railway.app /api/glue/event endpoint returns 404,
  // so glue-offer event tracking is now a no-op (call sites kept intact).
  function trackGlueEvent(evt) {}

  // ─── Modal ────────────────────────────────────────────────────────────────

  var modalOpen = false;
  var SESSION_KEY = 'ema-glue-prompted';

  function showModal(onAccept, onDecline) {
    if (modalOpen) return;
    // Only show once per browser session (tab lifetime)
    try { if (sessionStorage.getItem(SESSION_KEY)) return; } catch (error) {}
    modalOpen = true;
    try { sessionStorage.setItem(SESSION_KEY, '1'); } catch (error) {}
    trackGlueEvent('shown');

    // Dark backdrop (click-to-dismiss)
    var backdrop = document.createElement('div');
    backdrop.className = 'ema-glue-backdrop';

    // Modal centering wrapper + card
    var wrapper = document.createElement('div');
    wrapper.className = 'ema-glue-wrapper';
    wrapper.setAttribute('role', 'dialog');
    wrapper.setAttribute('aria-modal', 'true');
    wrapper.setAttribute('aria-labelledby', 'ema-glue-title');

    var previousFocus = document.activeElement;
    function escapeText(value) { var node = document.createElement('span'); node.textContent = String(value); return node.innerHTML; }
    var _cfg = getCfg();
    wrapper.innerHTML = [
      '<div class="ema-glue-modal">',
      '  <div class="ema-glue-modal__badge">✦ Exclusive Offer ✦</div>',
      '  <div class="ema-glue-modal__icon">🪸</div>',
      '  <h2 class="ema-glue-modal__title" id="ema-glue-title">Add Coral Glue?</h2>',
      '  <p class="ema-glue-modal__body">',
      '    Would you like to add <strong>EMA Premium Coral Glue</strong> to your order?',
      '    <span class="ema-glue-modal__deal">Only ' + escapeText(_cfg.gluePrice || '$20.00') + ' &mdash; save ' + escapeText(_cfg.glueSave || '$10.00') + '!</span>',
      '  </p>',
      '  <div class="ema-glue-modal__divider"></div>',
      '  <div class="ema-glue-modal__actions">',
      '    <button type="button" class="ema-glue-btn ema-glue-btn--yes" id="ema-glue-yes">✦ Yes, add it!</button>',
      '    <button type="button" class="ema-glue-btn ema-glue-btn--no" id="ema-glue-no">No thanks</button>',
      '  </div>',
      '</div>',
    ].join('');

    document.body.appendChild(backdrop);
    document.body.appendChild(wrapper);

    var stopConfetti;

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        backdrop.classList.add('ema-glue-backdrop--visible');
        wrapper.classList.add('ema-glue-wrapper--visible');
        stopConfetti = launchConfetti();
      });
    });

    var closing = false;
    function close(outcome) {
      if (closing) return;
      closing = true;
      document.removeEventListener('keydown', onKeydown);
      trackGlueEvent(outcome === 'accepted' ? 'accepted' : 'declined');
      if (stopConfetti) stopConfetti();
      backdrop.classList.remove('ema-glue-backdrop--visible');
      wrapper.classList.remove('ema-glue-wrapper--visible');
      setTimeout(function () {
        backdrop.remove();
        wrapper.remove();
        modalOpen = false;
        if (previousFocus && previousFocus.isConnected && typeof previousFocus.focus === 'function') previousFocus.focus();
      }, 350);
    }

    document.getElementById('ema-glue-yes').addEventListener('click', function () {
      close('accepted'); onAccept();
    });
    document.getElementById('ema-glue-no').addEventListener('click', function () {
      close('declined'); onDecline();
    });
    backdrop.addEventListener('click', function () { close('declined'); onDecline(); });
    function onKeydown(event) {
      if (event.key === 'Escape') { event.preventDefault(); close('declined'); onDecline(); return; }
      if (event.key !== 'Tab') return;
      var yes = wrapper.querySelector('#ema-glue-yes');
      var no = wrapper.querySelector('#ema-glue-no');
      if (event.shiftKey && (document.activeElement === yes || !wrapper.contains(document.activeElement))) {
        event.preventDefault(); no.focus();
      } else if (!event.shiftKey && (document.activeElement === no || !wrapper.contains(document.activeElement))) {
        event.preventDefault(); yes.focus();
      }
    }
    document.addEventListener('keydown', onKeydown);
    wrapper.querySelector('#ema-glue-no').focus();
  }

  // ─── Discount code ────────────────────────────────────────────────────────

  var discountApplied = false;

  function applyDiscount() {
    var code = getCfg().discountCode;
    if (discountApplied || !code) return;
    discountApplied = true;
    var iframe = document.createElement('iframe');
    iframe.style.cssText = 'position:absolute;width:0;height:0;border:0;visibility:hidden;';
    iframe.src = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
    document.body.appendChild(iframe);
    setTimeout(function () { if (iframe.parentNode) iframe.remove(); }, 8000);
  }

  // ─── Cart helpers ─────────────────────────────────────────────────────────

  function isCoralItem(item) {
    return (item.product_type || '').toLowerCase().indexOf('coral') !== -1;
  }

  function cartHasGlue(cartItems) {
    var vid = String(getCfg().glueVariantId || CORAL_GLUE_VARIANT_ID);
    return cartItems.some(function (i) { return String(i.variant_id) === vid; });
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } }).then(function (r) { if (!r.ok) throw new Error('Cart unavailable'); return r.json(); });
  }

  function addGlueToCart() {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: getCfg().glueVariantId || CORAL_GLUE_VARIANT_ID, quantity: 1 }] })
    }).then(function (r) { if (!r.ok) throw new Error('Glue could not be added'); return r.json(); }).then(function (data) {
      var confirmed = Array.isArray(data.items) ? data.items : data && data.id ? [data] : [];
      if (!confirmed.some(function (item) { return String(item.variant_id || item.id) === String(getCfg().glueVariantId || CORAL_GLUE_VARIANT_ID); })) throw new Error('Glue addition was not confirmed');
      applyDiscount();
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    });
  }

  function maybePromptGlue(addedItems) {
    var hasCoral = addedItems.some(function (item) { return isCoralItem(item); });
    if (!hasCoral) return;
    fetchCart().then(function (cart) {
      if (!cart || !Array.isArray(cart.items) || cartHasGlue(cart.items)) return;
      showModal(
        function () { addGlueToCart().catch(function () {}); },
        function () {}
      );
    }).catch(function () {});
  }

  document.addEventListener('ema:cart-add-success', function (event) {
    var items = event.detail && event.detail.items;
    if (!Array.isArray(items) || !items.length) return;
    maybePromptGlue(items);
  });

})();
